import React, { PropTypes } from 'react';
import axios from './../../../../constants/axios';
import { Table } from 'react-bootstrap';

class ExpenseInvoiceDetailItem extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         invoiceItems: []
      };
   }

   componentDidMount() {
      const { invoiceId } = this.props.params;
      axios.get(`expenses/getItemsByInvoiceId/${invoiceId}`)
         .then((res) => {
            this.setState({
               invoiceItems: res.data
            });
         });
   }

   render() {
      const { invoiceItems } = this.state;
      return (
         <div>
            <h4>Invoice Items</h4>
            <Table>
               <thead>
               <tr>
                  <th>Account Id</th>
                  <th>Account Name</th>
                  <th>Amount</th>
               </tr>
               </thead>
               <tbody>
               {invoiceItems.map((item) => (
                  <tr key={item.chart_of_account_id} >
                     <td>{item.chart_of_account_id}</td>
                     <td>{item.account_name}</td>
                     <td>{item.amount}</td>
                  </tr>
               ))}
               </tbody>
            </Table>
         </div>
      );
   }
}

ExpenseInvoiceDetailItem.propTypes = {
   params: PropTypes.object
};

export default ExpenseInvoiceDetailItem;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/Expense/ExepnseInvoiceDetail/ExpenseInvoiceDetailItem.js
 **/